import BaseModel from '../../../../base/base_model';
import {KEY_NAME} from '../../native/native_const';
import Store from '../../../../utils/store';
import _ from '../../../../utils/underscore';

class HybridInfoModel extends BaseModel {

    static CLASS = 'HybridInfoModel';

    _debugMode = false;
    _autologinToken = null;
    _sessionTimerOffset = null;
    _reload = false;
    _url = '';
    _urlType = '';
    _ListInfo = [];


    /*
     * init the params to be an json object.
     * @params is string from web.config
     * @params is json object from html
     */
    init(params) {
        super.init(params);
    }

    updateData(data) {
        this._debugMode = KEY_NAME.DEBUG === data[KEY_NAME.ACTION];
        this._autologinToken = data[KEY_NAME.AUTOLOGIN];
        this._sessionTimerOffset = data[KEY_NAME.SESSIONTIMER];
        this._reload = data[KEY_NAME.RELOAD];
        this._url = data[KEY_NAME.URL];
    }

   getAutologinToken() {
        return this._autologinToken;
   }

    getSessionTimerOffset() {
        try {
            return parseInt(this._sessionTimerOffset);
        } catch(err) {
            return null;
        }
    }

   getUrl() {
        return this._url;
   }

    getReload() {
        return this._reload;
    }

    isDebugMode() {
        return this._debugMode;
    }

    checkData(data) {
        if (data[KEY_NAME.DATA] !== undefined) {
            return data;
        }

        data = _.safeJSONandDecode(data);
        return data[KEY_NAME.DATA];
    }

    updateAllInfo(data) {

        data = this.checkData(data);

        if (null === data) {
            return;
        }

        this._updateAllKeys(data);
    }

    _updateAllKeys(data) {
        Object.keys(data).forEach((key) => {
            this._addKeys(key,data[key])
        });

        this._addKeys('CurrentUrl',window.location.href.toLowerCase());
    }

    _addKeys(key,data){
        Store.set(key,data);
        this._addToList(key, data);
    }

    _addToList(key, val) {

        const obj = {key: key, val: val};
        const objIndex = this._ListInfo.findIndex((obj => obj.key === key));

        if(objIndex > -1){
            this._ListInfo[objIndex].val = val;//replace
        }else{
            this._ListInfo.push(obj);//add
        }
    }

    getVal(key, defaultVal) {
        return Store.get(key, defaultVal);
    }

    getInfo() {
        return this._ListInfo;
    }

}

export default HybridInfoModel;
